<script setup lang="ts">
import { toRefs } from 'vue';
import { useFeatureToggle } from '@environment/useFeatureToggle';
import VPageContainer from '@shared/layout/VPageContainer/VPageContainer.vue';

import RelatiegegevensEmbed from '../RelatiegegevensEmbed.vue';

const props = defineProps<{
  relatienummer: number;
}>();
const { relatienummer } = toRefs(props);
const documentenPaginaEnabled = useFeatureToggle('RelatieDocumentenPaginaToggle');
</script>

<template>
  <VPageContainer
    v-if="!documentenPaginaEnabled"
    gap="xs"
    container-size="deprecated_1600"
    title="Documenten"
  >
    <RelatiegegevensEmbed :relatienummer="relatienummer" tab="documenten" />
  </VPageContainer>
  <VPageContainer v-if="documentenPaginaEnabled">
    <p>PLACEHOLDER</p>
  </VPageContainer>
</template>
